import { z } from 'zod'
import { ErrorCode } from './errors'

export const PageMeta = z.object({
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  limit: z.number().int().positive(),
})
export type PageMeta = z.infer<typeof PageMeta>

export type Envelope<T> = {
  success: boolean
  data: T | null
  error: { code: ErrorCode; message: string } | null
  meta?: PageMeta
}

export const ok = <T>(data: T, meta?: PageMeta): Envelope<T> =>
  meta === undefined ? { success: true, data, error: null } : { success: true, data, error: null, meta }

export const fail = (code: ErrorCode, message: string): Envelope<never> => ({
  success: false,
  data: null,
  error: { code, message },
})

export const envelopeSchema = <T extends z.ZodType>(data: T) =>
  z.object({
    success: z.boolean(),
    data: data.nullable(),
    error: z.object({ code: ErrorCode, message: z.string() }).nullable(),
    meta: PageMeta.optional(),
  })
